import React from 'react';
import {
  Brain,
  TrendingUp,
  AlertTriangle,
  Radar,
  Layers,
  ArrowRight
} from 'lucide-react';

const AdvancedAnalytics: React.FC = () => {
  const analyticsModules = [
    {
      id: 'clustering',
      title: 'Clustering de Jugadores',
      description: 'Agrupa jugadores por similitudes usando K-Means y DBSCAN',
      icon: Layers,
      gradient: 'from-purple-600 via-violet-700 to-indigo-800',
      comingSoon: true
    },
    {
      id: 'similarity',
      title: 'Análisis de Similitud', 
      description: 'Encuentra jugadores similares usando PCA y machine learning',
      icon: TrendingUp,
      gradient: 'from-blue-600 via-blue-700 to-indigo-800',
      comingSoon: true
    },
    {
      id: 'alerts',
      title: 'Alertas de Scouting',
      description: 'Sistema automático de alertas para talentos jóvenes y oportunidades',
      icon: AlertTriangle,
      gradient: 'from-orange-600 via-red-700 to-pink-800',
      comingSoon: true
    },
    {
      id: 'radar',
      title: 'Comparación Radar',
      description: 'Gráficos radar avanzados para análisis detallado de jugadores',
      icon: Radar,
      gradient: 'from-green-600 via-emerald-700 to-teal-800',
      comingSoon: true
    },
    {
      id: 'prediction',
      title: 'Predicción Deep Learning',
      description: 'Predicción de rendimiento de jugadores usando redes neuronales',
      icon: Brain,
      gradient: 'from-indigo-600 via-indigo-700 to-indigo-800',
      comingSoon: true
    }
  ];

  return (
    <div className="space-y-12 animate-fade-in">
      {/* Header */}
      <div className="relative p-10 text-center space-y-6 bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-800 text-white shadow-xl rounded-2xl border border-purple-500/20">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-600/90 to-indigo-800/90 rounded-2xl"></div>
        <div className="relative z-10">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
              <Brain className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Analytics <span className="text-purple-100">Avanzado</span>
          </h1>
          <p className="text-lg text-purple-100 max-w-3xl mx-auto leading-relaxed">
            Herramientas de machine learning y análisis predictivo • Próximamente disponible
          </p>
        </div>
      </div>

      {/* Analytics Modules Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {analyticsModules.map((module, index) => {
          const Icon = module.icon;
          return (
            <div
              key={module.id}
              className="group bg-white rounded-3xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${module.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500 rounded-3xl`} />

              {/* Content */}
              <div className="relative">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${module.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-105 transition-all duration-300 shadow-lg`}>
                  <Icon className="w-8 h-8 text-white" />
                </div>

                {/* Title and Description */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {module.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {module.description}
                </p>

                {/* Coming Soon Badge */}
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                    Próximamente
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Coming Soon Message */}
      <div className="text-center py-16">
        <Brain className="w-20 h-20 text-neutral-400 mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-neutral-100 mb-4">Módulo en Desarrollo</h2>
        <p className="text-neutral-300 mb-8">Las funcionalidades de analytics avanzado estarán disponibles próximamente</p>
        <a
          href="/sporting"
          className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-300"
        >
          <ArrowRight className="w-4 h-4 mr-2" />
          Volver a Dirección Deportiva
        </a>
      </div>
    </div>
  );
};

export default AdvancedAnalytics;
